<template>
  <!-- Top Bar -->
  <div class="top-bar">
    <div class="container-xl px-4 d-flex justify-content-between">
      <div class="contact-info">
        <a
          href="mailto:info@koemansvastgoed.nl"
          class="d-inline-flex align-items-center text-white text-decoration-none"
        >
          <i class="bi bi-envelope me-2" aria-hidden="true"></i>
          <span class="visually-hidden">Email: </span>
          <span>info@koemansvastgoed.nl</span>
        </a>
      </div>
    </div>
  </div>

  <!-- Logo with extending black lines on a white background -->
  <nav
    :class="[
      'navbar',
      'navbar-expand-lg',
      'border-bottom',
      'sticky-top',
      isSticky ? 'bg-white is-sticky' : 'bg-light',
    ]"
    ref="navbar"
  >
    <div class="logo-bar w-100 overflow-hidden">
      <img
        src="../assets/koemansvastgoed-extension.png"
        alt="Koemans Vastgoed Logo"
        class="logo-image"
      />
      <img
        src="../assets/koemansvastgoed.png"
        alt="Koemans Vastgoed Logo"
        class="logo-image"
      />
      <img
        src="../assets/koemansvastgoed-extension.png"
        alt="Koemans Vastgoed Logo"
        class="logo-image"
      />
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeaderComponent",
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const enterStickyAt = 50;
      const exitStickyAt = 30;

      if (!this.isSticky && window.scrollY > enterStickyAt) {
        this.isSticky = true;
      } else if (this.isSticky && window.scrollY < exitStickyAt) {
        this.isSticky = false;
      }
    },
  },
};
</script>

<style scoped>
.top-bar {
  color: white;
  padding: 5px 0;
  background-color: #488845;
}

/* Logo Bar Container */
.logo-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

/* Logo Image Default */
.logo-image {
  max-height: 175px;
  width: auto;
  height: auto;
  transition: all 0.3s ease;
}

/* When nav becomes sticky - shrink logo images */
nav.is-sticky .logo-image {
  max-height: 100px; /* 50% of 175px */
}
</style>
